import type { CSSProperties } from 'react'

type Props = {
  title: string
  value: string
  delta?: string
  secondary?: string
  accent?: string
  left?: number
  top?: number
}

export const TooltipCard = ({ title, value, delta, secondary, accent, left, top }: Props) => {
  const positioned = typeof left === 'number' && typeof top === 'number'
  const style: CSSProperties = positioned
    ? {
        left,
        top,
        transform: 'translate(-50%, calc(-100% - 12px))',
        borderColor: accent ? `color-mix(in srgb, ${accent} 42%, var(--border))` : undefined,
        boxShadow: accent ? 'var(--shadow-pop)' : undefined,
      }
    : {}
  return (
    <div
      className={`analysisChartTooltipCard${positioned ? ' analysisChartTooltipCard--positioned' : ''}`}
      role="tooltip"
      style={style}
    >
      {accent && <span className="analysisChartTooltipCard__dot" style={{ background: accent }} aria-hidden="true" />}
      <span className="analysisChartTooltipCard__title">{title}</span>
      <strong className="analysisChartTooltipCard__value">{value}</strong>
      {delta && <em className="analysisChartTooltipCard__delta">{delta}</em>}
      {secondary && <small className="analysisChartTooltipCard__secondary">{secondary}</small>}
    </div>
  )
}
